<template>
  <div id="app">
    <NavBar />
    <b-container class="bv-example-row">
      <b-row class="my-5" />
      <b-row align-h="center">
        <b-col sm="3">
          <b-img
            src="../../assets/modern_frozen_products_logo.png"
            fluid
            alt="Responsive image"
          ></b-img>
        </b-col>
      </b-row>
      <b-row align-h="center" class="mt-2">
        <h1 class="mx-auto">
          <b-badge variant="success">Modern Frozen Products</b-badge>
        </h1>
      </b-row>
      <b-row align-h="center" class="mt-2">
        <b-col>
          <b-card no-body class="overflow-hidden">
            <b-row no-gutters>
              <b-col md="6">
                <b-card-body>
                  <b-card-text>
                    <div>
                      <h3 style="font-weight: bold;">OUR PRODUCT LIST</h3>
                      <p>
                        We can supply any of the following products in any qty.
                        required by you:
                      </p>
                      <ol>
                        <li v-b-modal.peas-modal>
                          <b-link>IQF Green Peas (Packings available: 30 kg loose, 5 kg,
                          1 kg, 500 g and 200 g)</b-link>
                        </li>
                        <b-modal id="peas-modal" size="lg">
                          <b-img src="../../assets/frozen_green_peas.jpg" fluid/>
                        </b-modal>

                        <li v-b-modal.sweet-corn-modal>
                          <b-link>IQF/Blast Sweet Corn</b-link>
                        </li>
                        <b-modal id="sweet-corn-modal" size="lg">
                          <b-img src="../../assets/frozen_sweet_corn.jpg" fluid/>
                        </b-modal>

                        <li v-b-modal.mix-veg-modal>
                          <b-link>IQF Mix Vegetable</b-link>
                        </li>
                        <b-modal id="mix-veg-modal" size="lg">
                          <b-img src="../../assets/frozen_mixed_vegetable.jpg" fluid/>
                        </b-modal>

                        <li v-b-modal.carrot-modal>
                          <b-link>IQF Carrot</b-link>
                        </li>
                        <b-modal id="carrot-modal" size="lg">
                          <b-img src="../../assets/frozen_carrot_diced.jpg" fluid/>
                        </b-modal>

                        <li v-b-modal.beans-modal>
                          <b-link>IQF Beans</b-link>
                        </li>
                        <b-modal id="beans-modal" size="lg">
                          <b-img src="../../assets/frozen_cut_beans.jpg" fluid/>
                        </b-modal>

                        <li v-b-modal.cauliflower-modal>
                          <b-link>IQF Cauliflower</b-link>
                        </li>
                        <b-modal id="cauliflower-modal" size="lg">
                          <b-img src="../../assets/frozen_cauliflower_florets.jpg" fluid/>
                        </b-modal>

                        <li v-b-modal.baby-corn-modal>
                          <b-link>IQF Baby Corn</b-link>
                        </li>
                        <b-modal id="baby-corn-modal" size="lg">
                          <b-img src="../../assets/frozen_baby_corn.jpg" fluid/>
                        </b-modal>

                        <li v-b-modal.broccoli-modal>
                          <b-link>IQF Broccoli</b-link>
                        </li>
                        <b-modal id="broccoli-modal" size="lg">
                          <b-img src="../../assets/frozen_broccoli_florets.jpg" fluid/>
                        </b-modal>

                        <li v-b-modal.corn-on-cob-modal>
                          <b-link>Corn on cob</b-link>
                        </li>
                        <b-modal id="corn-on-cob-modal" size="lg">
                          <b-img src="../../assets/corn_on_cob.jpg" fluid/>
                        </b-modal>

                        <li>
                          Any other vegetable can be processed on confirmed
                          order in any quantity during season.
                        </li>
                        <li>
                          We also deal in supply of raw vegetables to factories.
                        </li>
                      </ol>
                      <hr />
                      <h4 style="font-weight: bold;">
                        OUR MAIN SPECIALISATION - IQF FROZEN GREEN PEAS
                      </h4>
                      <p>
                        We supply bulk quantities of only high quality
                        individually quick frozen (IQF) vegetables which are
                        harvested at the right maturity level. Our team of high
                        level professionals impose the industry’s highest
                        quality standards and ensure that only supreme quality
                        frozen green peas and vegetables are supplied. Select
                        the package that is right for your needs.
                      </p>
                      <h4 style="font-weight: bold;">
                        Technical Specifications of IQF Green Peas :
                      </h4>
                      <p>
                        Color : Natural green
                        <br />
                        Size : 6-10 mm
                        <br />
                        Store temperature: below -18&deg;C
                        <br />
                        Shelf life: 12 months
                        <br />
                        Available period: All year round good quality
                      </p>
                    </div>
                  </b-card-text>
                </b-card-body>
              </b-col>
              <b-col md="6">
                <Carousel />
              </b-col>
            </b-row>
            <b-row class="px-4">
              <b-col>
                <p>
                  For technical specification of our other products, please
                  email at
                  <a href="mailto:ashwini.bindu@gmail.com?subject="
                    >ashwini.bindu@gmail.com</a
                  >
                </p>
                <hr />
                <h4 style="font-weight: bold;" id="minOrder">Minimum Order</h4>
                <ul>
                  <li>
                    Minimum 14 MT or any above quantity all over India.
                  </li>
                  <li>
                    Booking facility also available.
                  </li>
                </ul>
                <hr />
                <h4 style="font-weight: bold;">PERSONALISED BRANDING</h4>
                <ul>
                  <li>
                    Packings can also be provided as per buyer’s need.
                  </li>
                  <li>
                    We can also provide the facility of packing in your own
                    brand with a nominal actual labour cost.
                  </li>
                  <li>
                    We can also supply any combination of packings as per
                    buyers' requirements.
                  </li>
                  <li>
                    Packing is done at factory level in most hygienic
                    conditions.
                  </li>
                  <li>
                    Frozen peas and vegetable are natural and contain no
                    preservatives or additives.
                  </li>
                  <li>
                    Export packing facility also available on confirmed order.
                  </li>
                </ul>
                <hr />
                <h4>Shelf-life of all our frozen products</h4>
                <p>
                  12 months from the date of manufacturing (if kept at -18°C or
                  below).
                </p>
                <hr />
                <h4 style="font-weight: bold;">Price</h4>
                <p>
                  We offer A Plus Grade Frozen products at best competitive
                  rates. Quotation available on request.
                </p>
                <p>
                  For price/best quote please call at
                  <abbr title="Phone">Mobile:</abbr> +91-9815411199 (WhatsApp),
                  +91-9779246448 or Email us your requirement at
                  <a href="mailto:ashwini.bindu@gmail.com?subject="
                    >ashwini.bindu@gmail.com</a
                  >
                  .
                </p>
                <hr />
                <h4 style="font-weight: bold;">
                  Some extra knowledge about peas: Fresh peas vs Frozen peas
                </h4>
                <p>
                  Peas' sugars turn into starch as soon as they are picked.
                  After 24 hours, those sweet little green gems can be grainy
                  and dull-tasting. Frozen peas, on the other hand, are picked
                  and frozen at the peak of ripeness, halting the process of
                  sugars turning to starch, so frozen peas are much better and
                  will have the sweet taste you're looking for even after
                  several months without any addition of preservatives! Plus,
                  you don't have to do any podding! Generally, frozen
                  vegetables/products retain more vitamins and seems to taste
                  fresher. Frozen vegetables/products have advantages over fresh
                  ones as the same are available when the fresh counterpart is
                  out-of-season. They have practically infinite shelf life when
                  kept in a freezer.
                </p>
                <hr />
                <h4 style="font-weight: bold;">Knowledge on Recovery/yield</h4>
                <p>
                  Fresh peas with pods have approximately 35% to 40% recovery
                  i.e. for every 1 kg of pea pod you buy you will get only about
                  350 to 400 grams of peas so buying 1 kg of frozen peas is
                  equivalent to buying 2.5 kg of peas with pods. This means that
                  the cost and effort of using frozen peas is very less!
                </p>
                <p>
                  As long ago as 1959, sales of frozen peas in Britain overtook
                  sales of pods, despite the fact that very few households owned
                  a freezer at this point.
                </p>
                <p>
                  In India, still only about 10% of the peas consumption is of
                  frozen peas and 90% of peas are consumed fresh. This is
                  primarily due to unawareness in Indian consumers that frozen
                  peas are as healthy, nutritious and sweet as freshly picked
                  peas. Also they are much cheaper than peas with pods during
                  off-season and don’t require any podding.
                </p>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import NavBar from "../../components/NavBar";
import Carousel from "../../components/Carousel";

export default {
  name: "App",
  components: {
    NavBar,
    Carousel,
  },
};
</script>

<style>
body {
  background-image: url("../../assets/background.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
}
</style>
